(() => {
  if (customElements.get('bc-navigation')) return;
  class BCNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.items = [...this.querySelectorAll('[data-bc-item]')];
      this.active = null;
      this.desktop = window.matchMedia('(min-width: 768px)');
      this.hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.setAttribute('data-bc-ready', '');
      this.items.forEach(item => {
        const panel = item.querySelector('[data-bc-panel]');
        const toggle = item.querySelector('button');
        item.addEventListener('keydown', event => this.onKey(event, item), options);
        if (!panel) {
          item.addEventListener('pointerenter', () => this.close(), options);
          item.addEventListener('focusin', () => this.close(), options);
          return;
        }
        panel.inert = true;
        item.addEventListener('pointerenter', event => {
          clearTimeout(this.timer);
        }, options);
        item.querySelector('.bc-navigation__link').addEventListener('pointerenter', event => {
          if (this.hover.matches && event.pointerType !== 'touch') this.open(item);
        }, options);
        item.addEventListener('pointerleave', () => {
          this.timer = setTimeout(() => {
            if (!item.contains(document.activeElement)) this.close();
          }, 220);
        }, options);
        item.addEventListener('focusin', event => {
          if (event.target !== toggle) this.open(item);
        }, options);
        toggle.addEventListener('click', () => {
          if (this.active === item) {
            this.close();
          } else {
            this.open(item, toggle);
          }
        }, options);
      });
      this.addEventListener('focusout', () => {
        setTimeout(() => { if (this.isConnected && !this.contains(document.activeElement)) this.close(); }, 0);
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.active) {
          const link = this.opener || this.active.querySelector('.bc-navigation__link');
          const restoreFocus = this.contains(document.activeElement);
          if (restoreFocus) link.focus();
          this.close();
          event.preventDefault();
        }
      }, options);
      this.desktop.addEventListener('change', () => this.close(), options);
      window.addEventListener('resize', () => { if (this.active) this.position(this.active); }, options);
      window.addEventListener('scroll', () => { if (this.active) this.position(this.active); }, { ...options, passive: true });
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.bc-promo');
        const item = card?.closest('[data-bc-item]');
        if (item && this.contains(item)) this.open(item);
      }, options);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    position(item) {
      const panel = item.querySelector('[data-bc-panel]');
      const rect = this.getBoundingClientRect();
      const trigger = item.querySelector('.bc-navigation__trigger').getBoundingClientRect();
      panel.style.setProperty('--bc-panel-height', `${Math.max(80, window.innerHeight - trigger.bottom - 20)}px`);
      panel.style.top = `${trigger.bottom - rect.top}px`;
      if (panel.classList.contains('bc-navigation__panel--dropdown')) {
        panel.style.setProperty('--bc-dropdown-left', `${Math.max(16, Math.min(trigger.left - rect.left, rect.width - panel.offsetWidth - 16))}px`);
      }
    }
    open(item, opener = null) {
      clearTimeout(this.timer);
      if (!this.desktop.matches) return;
      const panel = item.querySelector('[data-bc-panel]');
      if (!panel) { this.close(); return; }
      if (this.active !== item) {
        this.close();
        this.active = item;
        this.opener = opener || item.querySelector('.bc-navigation__link');
        this.previousPreventHide = this.closest('sticky-header')?.preventHide;
        if (this.closest('sticky-header')) this.closest('sticky-header').preventHide = true;
        this.closest('.section-header')?.classList.add('bc-navigation-active');
        item.setAttribute('data-bc-open', '');
        panel.inert = false;
        item.querySelectorAll('[aria-expanded]').forEach(el => el.setAttribute('aria-expanded', 'true'));
      }
      this.position(item);
    }
    close() {
      clearTimeout(this.timer);
      if (!this.active) return;
      this.active.removeAttribute('data-bc-open');
      this.active.querySelector('[data-bc-panel]').inert = true;
      this.active.querySelectorAll('[aria-expanded]').forEach(el => el.setAttribute('aria-expanded', 'false'));
      this.active = null;
      if (this.closest('sticky-header')) this.closest('sticky-header').preventHide = this.previousPreventHide;
      this.closest('.section-header')?.classList.remove('bc-navigation-active');
    }
    onKey(event, item) {
      const trigger = event.target.closest('.bc-navigation__trigger');
      if (trigger && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        this.open(item, event.target);
        const links = [...item.querySelectorAll('[data-bc-panel] a')];
        const destination = event.key === 'ArrowDown' ? links[0] : links.at(-1);
        requestAnimationFrame(() => { if (this.active === item) destination?.focus(); });
      }
      if (trigger && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const i = this.items.indexOf(item);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + this.items.length) % this.items.length;
        this.close();
        this.items[next].querySelector('.bc-navigation__link').focus();
      }
    }
  }
  customElements.define('bc-navigation', BCNavigation);
})();

